import { BridgeClient } from "../../../clients/BridgeApi";

export default ( bridgeClient: BridgeClient ) => (
  incident: Omit<DataModel.Incident, "uid">
) => bridgeClient.post(
  '/incident', 
  incident as unknown as JSON
);